import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu08",
  "use": "icon-menu08-usage",
  "viewBox": "0 0 52 52",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 52 52\" id=\"icon-menu08\">\r\n<path fill=\"currentColor\" d=\"M26.001,2.261L0,49.582h26.001H52L26.001,2.261z M29.572,21.167l-1.044,16.469h-5.063l-1.042-16.469H29.572z M25.995,44.669\r\n\tc-2.603,0-4.39-0.929-4.39-2.121c0-1.239,1.861-2.139,4.39-2.139c2.679,0,4.395,0.899,4.395,2.139\r\n\tC30.39,43.74,28.674,44.669,25.995,44.669z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol